import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Pricingmain = ({
  isAtTop,
  imgrad,
  selectedValue,
  handleChangeGetDetails,
  areas,
  proceedtonext,
  weekOptions,
  selectedWeek,
  pricselectedMonth,
  handleChangeMonth,
  availableSonographyOptions,
  selectedSonography,
  handleSonographyChange,
}) => {
  const [isSonographyDropdownOpen, setIsSonographyDropdownOpen] = useState(false);
  const sonographyDropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sonographyDropdownRef.current &&
        !sonographyDropdownRef.current.contains(event.target)
      ) {
        setIsSonographyDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setIsSonographyDropdownOpen(false);
  }, [selectedWeek]);

  const selectedSonographyLabels = availableSonographyOptions
    ?.filter((item) => selectedSonography.includes(String(item.id)))
    .map((item) => item.name);

  return (
    <>
      <div className="mt-5">
        <div className="mt-5">
          <div className="container p pt-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <p className="under-subtitle py-4 bold-font ">
                  Finding the right pregnancy care that is not heavy on your
                  pocket is more like a task. To reduce your burden we help
                  anytime anyday with the best all inclusive pregnancy care at
                  an affordable rate.
                </p>
              </div>
              <div className="col-md-6">
                <img src="/savemoney.png" className="w-100" />
              </div>
            </div>
          </div>
          {/* New time line section */}
          {/* <div> */}
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h2 className="hero-title text-red text-center">
                    Your Baby Deserves the Best, Without Breaking the Bank!
                  </h2>
                </div>
                <div className="timeline">
                  <div className="timeline-line"></div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div className="container01 left-container01">
                      <img src="/timeline.png" alt="Timeline"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">
                          The million-dollar question – How are we affordable
                          yet promise the best prenatal care?
                        </h2>
                        <p className="bold-font">
                          We aim to provide technology-driven and standardized
                          pregnancy care solutions to everyone without pursuing
                          huge profits. Yes, there are costs involved, and we
                          also need money to sustain the model, but we believe
                          that if a major technological breakthrough is not
                          shared with everyone, then what’s the use for it?
                        </p>
                        <p className="bold-font">
                          It’s as honest as a company can get.
                        </p>
                        <h3 className="second-title ">
                          Now, let’s talk numbers
                        </h3>
                      </div>
                    </div>

                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline01.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline02.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                    <div className="container01 right-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">
                          We claim to help you save up to ₹100,000 every
                          pregnancy. How?
                        </h2>
                        <p className="bold-font">
                          There’s a set expenditure involved in every step of
                          prenatal care. Doctor’s consultaons, lab tests,
                          sonography, regular visits to the hospital which may
                          be far from your residence, regular check-ups for
                          health care concerns arising due to pregnancy such as
                          Gestaonal Diabetes or Hypertensive Disorder, and not
                          to menon unplanned C-Secons, NICU stays, consultancy,
                          and monitoring charges{" "}
                        </p>
                        <p className="bold-font mt-2 mb-5">
                          {" "}
                          All this not only becomes fairly expensive for parents
                          but overwhelming too.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div className="container01 left-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">How MyPrega Helps?</h2>
                        <p className="bold-font">
                          You just need to select one of our prenatal packages
                          and you are done. No frequent travel is needed and we
                          even choose the best doctor for you in your locaon for
                          your convenience.{" "}
                        </p>
                        <h3 className="second-title ">There’s more!</h3>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline03.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline04.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                    <div className="container01 mobile-maging right-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box ">
                        <h2 className="hero_subtitle">
                          Indirect savings with MyPrega?
                        </h2>
                        <ul className="expensive-ul">
                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            Our pregnancy care model focuses on prevention
                            rather than treatment, so our experts try to reduce
                            the chances of health complications, increasing your
                            chances of having a normal delivery.
                          </li>

                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            You don’t even need to go anywhere for any kind of
                            consultaon, be it diet, yoga, meditaon, Garbha
                            Sanskar, or pregnancy educaon – our experts take
                            care of it all from the comfort of your home.
                          </li>
                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            No mental pressure due to unplanned C-Secon and
                            prolonged NICU stay.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2
              className="hero-title text-center"
            >
              Now tell us, have you heard of such an eecve prenatal care model
              before? We hadn’t either! That’s how MyPrega was born.{" "}
            </h2>
          </div>
          {/* </div> */}

          <div className="text-center">
            <h4
              className="mb-2 fw-bold text-center text-secondary mobunderline"
              style={{ fontSize: "22px" }}
            >
              Tell us about your Area
            </h4>
          </div>
          <br></br>
          <div className="text-center dropdowns">
            <form className="my-3">
              <select
                name="subject"
                id="subject"
                className="custom-select"
                value={selectedValue}
                onChange={handleChangeGetDetails}
              >
                <option value="">Select Area</option>
                {areas?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item?.name}
                  </option>
                ))}
              </select>
            </form>
          </div>
          {/* 🔹 Month Dropdown */}
          <div className="text-center dropdowns mt-3">
            <form className="my-3">
              <select
                name="month"
                id="month"
                className="custom-select"
                value={selectedWeek}
                onChange={handleChangeMonth}
              >
                <option value="">Select Week</option>
                {weekOptions?.map((item) => (
                  <option key={item.week} value={item.week}>
                    Week {item.week}
                  </option>
                ))}
              </select>
            </form>
          </div>
          {selectedWeek && (
            <div className="text-center dropdowns mt-3">
              <div
                className="my-3"
                ref={sonographyDropdownRef}
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  margin: "0 auto",
                  textAlign: "left",
                  position: "relative",
                }}
              >
                <button
                  type="button"
                  onClick={() =>
                    setIsSonographyDropdownOpen((prevState) => !prevState)
                  }
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    border: "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    fontSize: "16px",
                    color: selectedSonography.length > 0 ? "#000" : "#666",
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    minHeight: "48px",
                  }}
                >
                  <span>
                    {selectedSonography.length > 0
                      ? `${selectedSonography.length} sonography selected`
                      : "Select Sonography"}
                  </span>
                  <span style={{ fontSize: "12px", color: "#888" }}>
                    {isSonographyDropdownOpen ? "Close" : "Open"}
                  </span>
                </button>
                {selectedSonographyLabels?.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      marginTop: "10px",
                    }}
                  >
                    {selectedSonographyLabels.map((label) => (
                      <span
                        key={label}
                        style={{
                          backgroundColor: "#fff4f7",
                          color: "#c63d68",
                          border: "1px solid #f4bfd0",
                          borderRadius: "999px",
                          padding: "6px 10px",
                          fontSize: "12px",
                        }}
                      >
                        {label}
                      </span>
                    ))}
                  </div>
                )}
                {isSonographyDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      left: 0,
                      right: 0,
                      zIndex: 20,
                      backgroundColor: "#fff",
                      border: "1px solid #d9d9d9",
                      borderRadius: "8px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      maxHeight: "280px",
                      overflowY: "auto",
                      padding: "8px 0 0 0",
                    }}
                  >
                    {availableSonographyOptions?.map((item) => (
                      <label
                        key={item.id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "18px 1fr",
                          alignItems: "center",
                          columnGap: "10px",
                          padding: "10px 12px",
                          cursor: "pointer",
                          margin: 0,
                          width: "100%",
                        }}
                      >
                        <input
                          type="checkbox"
                          value={item.id}
                          checked={selectedSonography.includes(String(item.id))}
                          onChange={handleSonographyChange}
                          style={{ margin: 0 }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#222",
                            textAlign: "left",
                            lineHeight: "1.4",
                          }}
                        >
                          {item.name}
                        </span>
                      </label>
                    ))}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "12px 14px",
                        borderTop: "1px solid #eee",
                        backgroundColor: "#fff",
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => setIsSonographyDropdownOpen(false)}
                        style={{
                          backgroundColor: "#f0588b",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          padding: "8px 14px",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        Done
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="mx-3">
            <div className="my-2 buy">
              <Link
                href="#"
                className="mx-auto text-white"
                onClick={() => proceedtonext()}
              >
                PROCEED
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricingmain;
